import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Astound,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  ATT,
  BrightspeedV2,
  QuantumFiber,
  CenturyLink,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Earthlink,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

// Origin - https://updater.atlassian.net/browse/UPA-51
export const CordlessXfinityPartner: SingleProviderConfig = {
  name: 'CordlessXfinityPartner',
  micrositeCode: 'xfinitypartner',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '844-571-1132',
  fallbackLeadModePhoneNumber: '844-571-1132',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: true,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    BrightspeedV2,
    QuantumFiber,
    CenturyLink,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
    Earthlink,
  ],
  getCheckoutType: allLeadMode,
};
